import React, { Component } from "react";
import ClockLogo from '../../assets/timerWhite.png';
import Flexbox from 'flexbox-react';
import {inject} from 'mobx-react';

const shopListItemEtaDataWrapper = {
	"margin": "10% 15% 10% 10%",
	"height": "80%",
	"width": "75%",
};

const shopListItemEtaNumberWrapper = {
	"fontFamily": "GraphikSemibold",
	"fontSize": "2.45em",
};

const shopListItemEtaNumber = {
	"margin": "auto"
};

const clockLogo={
	"margin": "6% 5%",
	"width": "22%",
	"float":"left"
};
const clockUnits = {
	"fontFamily": "GraphikMedium",
	"paddingTop": "1%",
	"fontSize": "1em",
	"paddingRight": "5%",
	"margin": "3%",
	"float":"right"
};

@inject('RootStore')
export default class ShopListItemEtaBox extends Component {
    render() {
		let shopListItemEtaBoxStyle = {
			"color": "white",
			"textAlign": "center",
			"backgroundColor": "rgb(10, 136, 155)",
			"borderRadius": "0 50% 50% 0",
			"height": "100%",
			"width": "100%"
        };
        shopListItemEtaBoxStyle.backgroundColor = this.props.RootStore.styleStore.currentStylesDict.shopListEtaBoxOpenColor;

        return (
            <div style={shopListItemEtaBoxStyle}>
				<Flexbox style={shopListItemEtaDataWrapper} flexDirection="column">
					<Flexbox flexGrow={1} width="100%" height="7%"></Flexbox>
					<Flexbox style={shopListItemEtaNumberWrapper} width="100%">
						<div style={shopListItemEtaNumber}>
							{this.props.shop.eta ? this.props.shop.eta : '?'}
						</div>
					</Flexbox>
					<Flexbox width="100%" height="1%">
					</Flexbox>
					<Flexbox width="100%">
						<img style={clockLogo} src={ClockLogo} alt="" />
						<div style={clockUnits}>MIN</div>
					</Flexbox>
					<Flexbox flexGrow={.2} width="100%" height="2%">
					</Flexbox>
				</Flexbox>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/shop_list_item/shop_list_item_eta_box.jsx